// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loan__description .date[data-v-587ebd29]{color:#665f56;font-style:italic;margin-top:2rem}.loan__description .date svg[data-v-587ebd29]{color:#e6dab9;font-size:1.2rem;margin-right:.25rem;transform:translateY(1px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
